module.exports = "<div class=\"input-group input-group__money\">\n    <span class=\"input-group-label--currency\" ng-if=\"$ctrl.shouldDecorate('currency')\" ng-bind-html=\"$ctrl.currency.symbol\"></span>\n    <input type=\"text\" ng-model=\"$ctrl.value\" class=\"input-group-field\" ng-change=\"$ctrl.onChange()\" ng-focus=\"$ctrl.onFocus()\" ng-blur=\"$ctrl.onBlur()\" ng-disabled=\"$ctrl.disabled\">\n    <span class=\"input-group-label--percentage\" ng-if=\"$ctrl.shouldDecorate('percentage')\">\n        %\n    </span>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./frontend/admin/app/modules/shared/base/views/money.input.html
// module id = 605
// module chunks = 0